

import tmpl from '../_lib/template';


/**
 * Translate
 */
class Template {
    constructor(element, templateId, translation) {
        element.innerHTML = tmpl(templateId, translation);
    }

    static getTranslation(language, dictionary) {
        console.log('Template.getTranslation(language, dictionary) [language, dictionary]', language, dictionary);

        let translation = dictionary['WW'] || {};

        if (!dictionary[language] || language === 'WW') {
            return translation;
        }

        if (dictionary[language]['TEMPLATE']) {
            for (let [key, value] of Object.entries(this.getTranslation(dictionary[language]['TEMPLATE'], dictionary))) {
                translation[key] = value;
            }
        }

        for (let [key, value] of Object.entries(dictionary[language])) {
            translation[key] = value;
        }

        return translation;
    }
}


export default Template;

